import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=2c58d2f9&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=ts"
export * from "./NewPassword.vue?vue&type=script&lang=ts"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=2c58d2f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58d2f9",
  null
  
)

export default component.exports